<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save"  @imp="impt" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-table
                        id="xpane-0"
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="mevt_no" :label="$t('getapi[463]')"></el-table-column>
                    <el-table-column prop="status" :label="$t('getapi[552]')">
                        <template scope="scope">
                            <span>{{ exp(scope.row.status)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="firstqty" :label="$t('getapi[1628]')"></el-table-column>
                    <el-table-column prop="need_date" :label="$t('getapi[7889]')">
                        <template scope="scope">
                            <span>{{scope.row.need_date | toDate}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="pro_type" :label="$t('getapi[8256]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="binbox" :label="$t('getapi[8262]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="winbox" :label="$t('getapi[8263]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="leadcadrename" :label="$t('getapi[8265]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="leadcadreinbox" :label="$t('getapi[8266]')"></el-table-column>
                    <el-table-column prop="iswork" :label="$t('getapi[8257]')">
                         <template scope="scope">
                            <span>{{ scope.row.iswork | lanchange}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="machingprocess" :label="$t('getapi[8503]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="machingremarks" :label="$t('getapi[8504]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="size" :label="$t('getapi[8258]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="otherreq" :label="$t('getapi[8259]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="rawmaterial_code" :label="$t('getapi[8260]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="material_no" :label="$t('getapi[8261]')"></el-table-column>
                    <el-table-column prop="standardcosts" :label="$t('getapi[1973]')" align="right">
                        <template slot-scope="scope">
                            {{scope.row.standardcosts | thousandth}}
                        </template>
                    </el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:960px">
                    <div>
                        <el-button type="primary" size="mini" :disabled="!btnsubmit" @click="confirm">{{$t('getapi[6468]')}}</el-button>
                        
                        <el-button type="primary" size="mini" :disabled="dataDetail.Head.create_person != user || dataDetail.Head.status == 0 || dataDetail.Head.status == 5" @click="forceclose">{{$t('getapi[2345]')}}</el-button>
                    </div>
                    <div style="width:920px;min-width:920px">
                        <table>
                            <tr>
                                <td style="width:80px;min-width:90px">{{ $t('getapi[4754]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input v-model="dataDetail.Head.mevt_no" type="text"  style="width: 150px" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px;min-width:80px">{{ $t('getapi[876]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <routejump :urlNo="5" v-if="dataDetail.Head.status == 0">
                                    <el-input
                                            v-model="dataDetail.Head.item_code"
                                            type="text"
                                            readonly
                                            size="mini"
                                            class="mcolor"
                                            style="width: 150px"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectItem()"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input v-model="dataDetail.Head.item_code" v-if="dataDetail.Head.status != 0" :readonly="true" class="readO"
                                              size="mini"></el-input>
                                </td>

                                <td style="width:80px;min-width:80px">{{$t('getapi[7943]')}}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input v-model="dataDetail.Head.item_status_name" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                
                                <td style="width:80px;min-width:80px">{{$t('getapi[552]')}}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input :value="exp(dataDetail.Head.status)" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>  
                                <td style="width:80px">{{$t('getapi[7889]')}}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-date-picker v-model="dataDetail.Head.need_date" type="date" size="mini" value-format="yyyy/MM/dd" style="width:100%" :readonly="dataDetail.Head.status != 0" :class="{'readO':dataDetail.Head.status != 0}"></el-date-picker>
                                </td>                              
                                <td>
                                    <el-input v-model="dataDetail.Head.item_name" type="text" size="mini"
                                              :readonly="true" class="readO" v-if="false"></el-input>
                                </td>
                                
                            </tr>
                            <tr>
                                <td>{{$t('getapi[11857]')}}</td>
                                <td>
                                    <el-select filterable v-model="dataDetail.Head.pro_type" class="mcolor"  size="mini" :disabled="dataDetail.Head.status != 0">
                                        <el-option :label="$t('getapi[8730]')" value="铝机加件"></el-option>
                                        <el-option :label="$t('getapi[8731]')" value="不锈钢机加件"></el-option>
                                        <el-option :label="$t('getapi[8732]')" value="碳钢机加件"></el-option>
                                        <el-option :label="$t('getapi[8733]')" value="棒料"></el-option>
                                        <el-option :label="$t('getapi[8734]')" value="塑料板"></el-option>
                                        <el-option :label="$t('getapi[8735]')" value="钣金"></el-option>
                                        <el-option :label="$t('getapi[8736]')" value="采购机加件"></el-option>
                                    </el-select>
                                </td>
                                <td>{{$t('getapi[112]')}}</td>
                                <td>
                                    <routejump :urlNo="12" v-if="dataDetail.Head.status == 0">
                                    <el-input
                                            v-model="dataDetail.Head.part_code"
                                            type="text"
                                            readonly
                                            size="mini"
                                            class="mcolor"
                                            style="width: 150px"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectPart()"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input v-model="dataDetail.Head.part_code" v-if="dataDetail.Head.status !== 0" :readonly="true" class="readO"
                                              size="mini"></el-input>
                                </td>
                                <td>{{$t('getapi[149]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.part_version" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[1628]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.firstqty" size="mini"
                                              type="number" autocomplete="off" title="" @mousewheel.native.prevent :readonly="dataDetail.Head.status != 0" :class="{'readO':dataDetail.Head.status != 0}"></el-input>
                                </td>
                                <td>{{$t('getapi[8536]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.confirm_time" readonly="true" type="text" class="readO" size="mini"></el-input>
                                </td>
                                
                            </tr>
                            <tr>
                                
                                
                                <td>{{$t('getapi[8262]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.binbox" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[8263]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.winbox" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[8266]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.leadcadreinbox" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[13236]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.enginener_email" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[13237]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.inquiry_email" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                </td>                               
                                
                            </tr>
                            <tr>
                                <td>{{$t('getapi[143]')}}</td>
                                <td colspan="5" >
                                    <el-input v-model="dataDetail.Head.remarks" type="text" size="mini"></el-input>
                                </td>
                                <!-- <td>{{$t('getapi[8265]')}}</td> -->
                                <td>
                                    <el-input v-model="dataDetail.Head.leadcadrename" v-if="false"  type="text" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                           
                            <tr>
                                <td colspan="12">
                                    <el-divider content-position="left">{{$t('getapi[13188]')}}</el-divider>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[8257]')}}</td>
                                <td>
                                    <el-select filterable v-model="dataDetail.Head.iswork"  size="mini" :disabled="!btnengineer">
                                        <el-option :label="$t('getapi[561]')" value="可以"></el-option>
                                        <el-option :label="$t('getapi[866]')" value="完成"></el-option>
                                    </el-select>
                                </td>
                                <td>{{$t('getapi[8503]')}}</td>
                                <td>
                                    <routejump :urlNo="5" v-if="btnengineer">
                                    <el-input
                                            v-model="dataDetail.Head.machingprocess"
                                            type="text"
                                            readonly
                                            size="mini"
                                            class="mcolor"
                                            style="width: 150px"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectprocess()"></i>
                                    </el-input>
                                    </routejump>
                                    <!-- <el-input v-model="dataDetail.Head.item_code" v-if="dataDetail.Head.status != 0" :readonly="true" class="readO"
                                              size="mini"></el-input> -->
                                              
                                    <el-input v-model="dataDetail.Head.machingprocess" v-if="!btnengineer" :class="{'readO':dataDetail.Head.status != 1 && dataDetail.Head.status != 3}"></el-input>
                                </td>
                                <td>{{$t('getapi[13223]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.process_unit_price" disabled="true" type="number"   size="mini" ></el-input>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><el-button type="primary" size="mini" :disabled="!btnengineer" @click="engineerconfirm">{{$t('getapi[13230]')}}</el-button></td>
                            </tr>
                            <tr>
                                
                                <td>{{$t('getapi[13191]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.psm_minute" type="number" :disabled="!btnengineer" placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13192]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.omm_minute" type="number" :disabled="!btnengineer" placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13193]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.gr_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13194]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.dril_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13195]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.tapping_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                            </tr>
                            <tr>

                                
                               
                                <td>{{$t('getapi[13196]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.wedm_ms_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13197]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.wedm_hs_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13198]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.cnc_milling_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13199]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.cnc_one_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13201]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.cnc_two_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                            </tr>
                            <tr>
                                
                                
                                <td>{{$t('getapi[13202]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.cnc_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13203]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.cnc_gantry_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13204]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.gmc_minute" type="number" :disabled="!btnengineer"  placeholder="请输入整数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13205]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.cnc_precision_minute" type="number"  :disabled="!btnengineer"   size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13206]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.tax_inclusive_cost" type="number"  disabled="true"   size="mini" ></el-input>
                                </td>
                            </tr>
                            <tr>
                                
                                <td>{{$t('getapi[8504]')}}</td>
                                <td colspan="5">
                                    <el-input v-model="dataDetail.Head.machingremarks" type="text" size="mini" :readonly="dataDetail.Head.status != 1 && dataDetail.Head.status != 3" :class="{'readO':dataDetail.Head.status != 1 && dataDetail.Head.status != 3}"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="12">
                                    <el-divider content-position="left">{{$t('getapi[13190]')}}</el-divider>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[13207]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.material" type="txxt"  :disabled="!btninquiry" size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13208]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.gross_weight" type="number"  :disabled="!btninquiry"  step="0.01" placeholder="请输入小数" size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13209]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.unit_price" type="number" step="0.01" :disabled="!btninquiry" placeholder="请输入小数"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13210]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.material_cost" type="number" step="0.01" :disabled="!btninquiry" placeholder="请输入小数"  size="mini" ></el-input>
                                </td>
                                
                                <td></td>
                                <td><el-button type="primary" size="mini" :disabled="!btninquiry" @click="inquiryconfirm">{{$t('getapi[13231]')}}</el-button></td>
                                
                            </tr>
                            <tr>
                                <td>{{$t('getapi[13211]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.enquiryprice_tax" type="number" step="0.01"  :disabled="!btninquiry" size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13213]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.self_made_foe" type="text" disabled="true"  size="mini" ></el-input>
                                </td>
                                <td>{{$t('getapi[13212]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.material_category" type="txxt"  disabled="true"    size="mini" ></el-input>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <!-- v-if="dataDetail.Head.material_category=='自制'" -->
                                <td><el-button type="primary" size="mini" v-if="dataDetail.Head.material_category=='自制' && dataDetail.Head.self_made_foe!='Y'"   @click="proevaluationconfirm">{{$t('getapi[13239]')}}</el-button></td>
                            </tr>
                            <tr>
                                <td colspan="12">
                                    <el-divider content-position="left">{{$t('getapi[8269]')}}</el-divider>
                                </td>
                            </tr>
                            <tr>
                                <td>{{$t('getapi[8258]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.size" type="text" size="mini" :disabled="!btnmachining" ></el-input>
                                </td>
                                
                                <td>{{$t('getapi[8259]')}}</td>
                                <td colspan="5">
                                    <el-input v-model="dataDetail.Head.otherreq" type="text" size="mini" :disabled="!btnmachining" ></el-input>
                                </td>
                                <td></td>
                                <td><el-button type="primary" size="mini" :disabled="!btnmachining" @click="machiningconfirm">{{$t('getapi[8271]')}}</el-button></td>
                            </tr>                            
                            <tr>
                                <td colspan="12">
                                    <el-divider content-position="left">{{$t('getapi[8270]')}}</el-divider>
                                </td>
                            </tr>
                            <tr>                                
                                <td>{{$t('getapi[8260]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.rawmaterial_code" type="text" size="mini" :disabled="!btnpro" ></el-input>
                                </td>
                                <td>{{$t('getapi[8261]')}}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.material_no" type="text" size="mini" :disabled="!btnpro" ></el-input>
                                </td>
                                <td>{{$t('getapi[1973]')}}</td>
                               <td><el-input v-model="dataDetail.Head.standardcosts" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :disabled="!btnpro" ></el-input></td> 
                               <td></td>
                               <td></td>
                               <td></td>
                               <td><el-button type="primary" size="mini" :disabled="!btnpro" @click="proconfirm">{{$t('getapi[8272]')}}</el-button></td>
                               
                        
                            </tr>
                             
                        </table>
                    </div>
                </div>
                <div>
                    <div style="display: flex">
                        <el-button type="primary" size="mini" @click="batchdel" :disabled="selectData.length == 0 || dataDetail.Head.create_person != user">{{$t('getapi[7241]')}}</el-button>
                        <el-upload
                                class="upload-demo"
                                ref="upload"
                                action=""
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :on-change="handleChange"
                                :on-success="handleSuccess"
                                :on-error="handleError"
                                :http-request="uploadFile"
                                :auto-upload="true"
                                style="margin-left: 8px;"
                                :disabled="dataDetail.Head.mevt_no == '' || dataDetail.Head.create_person != user"
                        >
                            <el-button type="primary" size="mini" :disabled="dataDetail.Head.mevt_no == '' || dataDetail.Head.create_person != user">{{$t('getapi[6487]')}}
                            </el-button>
                        </el-upload>
                    </div>
                        <vxe-table
                            :data="dataDetail.List"
                            :highlight-current-row="true"
                            style="width: 96%; margin-top:3px"
                            resizable
                            show-overflow="tooltip"
                            :height="tableHeight - 490"
                            header-row-class-name="headerclass"
                            size="mini"
                            border
                            @checkbox-change="handleSelectionChange"
                            @checkbox-all="handleSelectionChangeAll"
                            @checkbox-range-end="handleSelectionChange"
                            ref="singleTable1"
                    >
                        <vxe-table-column type="checkbox" align="center" width="40"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="mevt_no" :title="$t('getapi[463]')"  width="120"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="filename" :title="$t('getapi[3590]')"  width="150"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="extension" :title="$t('getapi[8267]')"  width="100"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="size" align="right" :title="$t('getapi[7875]')"  width="100"></vxe-table-column>
                        <!-- <vxe-table-column show-footer-overflow field="path" :title="$t('getapi[8268]')"  width="100"></vxe-table-column> -->
                        <vxe-table-column show-footer-overflow field="createpersonname" :title="$t('getapi[410]')"  width="100"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="createtime" :title="$t('getapi[135]')"  width="120"></vxe-table-column>
                        <vxe-table-column align="center" :title="$t('getapi[6048]')" width="100">
                            <template slot-scope="scope">
                                <el-button slot="reference" type="text" size="small" @click.native.prevent="open(scope)">{{$t('getapi[3558]')}}</el-button>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ItemManagerInfo" ref="ser" @getser="serclick"></serce>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true  :postUrl="'Eng/MEvtManage/GetEngItemPopupView'" @callback="getItem" ref="item"></selector>

        <selector :isVisible="false" :isSplitPage="true" :postUrl="'Eng/MEvtManage/GetPartMasterPopupList'" @callback="getPart" ref="part"></selector>

        <selector :isVisible="false" :isSplitPage="true" :postUrl="'Eng/MEvtManage/GetEmployeeDataList'" @callback="getEmployee" ref="employee"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'Eng/MEvtManage/GetCraftProcPricePopupView'" @callback="getprocess" ref="process"></selector>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import {Loading} from 'element-ui';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
    export default {
        name: 'engmevtview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('engmevtview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {
                    Head:{},
                    List:[]
                }, // 编辑页面数据详情
                oldDataDetail: '',
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                addoredit: 1,
                code: '', // 单据唯一号
                file: '',
                FileList: [],
                selectData: [],
                btnsubmit:false,
                // 工程分析
                btnengineer:false,
                // 询价分析
                btninquiry:false,
                //机加工
                btnmachining:false,
                //开发
                btnpro:false,
                btnforceclose: false,
                scrollTop:0,
                scrollTop1:0,
            };
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('engmevtview', that)
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.authority()
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8255]"),this.$t("getapi[18]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.btnforceclose = false;
                if (that.$limits.authority('plv4', 556, 1) == 1) {
                    that.btnforceclose = true;
                } else {
                    that.btnforceclose = false;
                }
                if (that.$limits.authority('plv2', 556, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 556, 1) == 2) {
                    if (that.$limits.authority('plv3', 556, 1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 556, 1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export,import');
                    }
                    if (that.$limits.authority('plv3', 556, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.mevt_no)){
                            if(that.dataDetail.Head.status<=0){
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,del,import');
                            }
                            else{
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,import');
                            }

                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export,import');
                        }
                    }

                }
                if(that.dataDetail.Head.status>4){
                    that.$refs.SetBtn.SetOneBtnEnable('save', false)
                }

                if (!that.$limits.fnIsEmpty(that.dataDetail.Head.exclusively_id) && that.dataDetail.Head.status==0){
                   that.btnsubmit=true;
                }
                else{
                    that.btnsubmit=false;
                }
                that.btnengineer=false
                that.btninquiry=false
                that.btnpro=false
                that.btnmachining=false
                
                if(that.dataDetail.Head.status>=1){
                    if(that.dataDetail.Head.status==1){
                        that.btnengineer=true
                        that.btninquiry=true
                    }
                    if(that.dataDetail.Head.engineer_state==0){
                        that.btnengineer=true
                    }
                    if(that.dataDetail.Head.inquiry_state==0){
                        that.btninquiry=true
                    }
                    if(that.dataDetail.Head.pro_state==0 && that.dataDetail.Head.status>=2 &&  that.dataDetail.Head.inquiry_state==1){
                        that.btnpro=true
                    }
                    if(that.dataDetail.Head.machining_state==0 && that.dataDetail.Head.status>=2 &&  that.dataDetail.Head.inquiry_state==1){
                        that.btnmachining=true
                    }
                }
                else{
                    that.btnengineer=false
                    that.btninquiry=false
                    that.btnpro=false
                    that.btnmachining=false
                }
            },
            open(val){
                let that = this
                let path='http://' +window.location.host +'/'+ val.row.path;
                window.open(path,"_blank");                
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if (!that.iscontinuedblclick) {
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('engmevtview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'EngMEvtInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('Eng/MEvtManage/EngMEvtView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndexs)
                    });
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if (that.code == row.mevt_no) {
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.List.length;i++){
                        delete datacopy.List[i]['_XID'];
                    }
                    if (that.oldDataDetail != JSON.stringify(datacopy)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.mevt_no;
                                that.getDetail(that.code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.mevt_no;
                        that.getDetail(that.code);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                that.addoredit = 2;
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Eng/MEvtManage/GetEngMEvtInfo', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent){
                            that.dataDetail = res.DataContent;
                            that.oldDataDetail = JSON.stringify(that.dataDetail)
                            that.authority();
                        }
                    }
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.List.length;i++){
                    delete datacopy.List[i]['_XID'];
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this;
                let datetime = Common.methods.getDatetime();
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        exclusively_id:'',
                        mevt_no:'',
                        itemid:'',
                        item_code:'',
                        item_name:'',
                        item_status:'',
                        item_status_name:'',
                        item_duty_person:'',
                        status:0,
                        status_name:'',
                        partid:'',
                        part_code:'',
                        part_version:'',
                        firstqty:'',
                        need_date:'',
                        description:'',
                        pro_type:'',
                        iswork:'',
                        size:'',
                        otherreq:'',
                        rawmaterial_code:'',
                        material_no:'',
                        standardcosts:'',
                        create_person:'',
                        create_time:'',
                        modify_person:'',
                        modify_time:'',
                        confirm_person:'',
                        confirm_time:'',
                        remarks:'',
                        binbox:'',
                        winbox:'',
                        leadcadrecode:'',
                        leadcadrename:'',
                        leadcadreinbox:'',
                        machingprocess:'',
                        process_unit_price:0,
                        machingremarks:'',
                        psm_minute:0,
                        omm_minute:0,
                        gr_minute:0,
                        dril_minute:0,
                        tapping_minute:0,
                        wedm_ms_minute:0,
                        wedm_hs_minute:0,
                        cnc_one_minute:0,
                        cnc_two_minute:0,
                        cnc_minute:0,
                        gmc_minute:0,
                        cnc_precision_minute:0,
                        tax_inclusive_cost:0,
                        material:'',
                        gross_weight:'',
                        unit_price:0,
                        material_cost:0,
                        enquiryprice_tax:0,
                        material_category:'',
                        self_made_foe:'',
                        cnc_gantry_minute:0,
                        cnc_milling_minute:0,
                        enginener_email:'',
                        inquiry_email:'',
                    },
                    List : [],
                };
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.List.length;i++){
                    delete datacopy.List[i]['_XID'];
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if (that.addoredit != 1) {
                                that.getView();
                                that.getDetail(that.code)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if (that.addoredit != 1) {
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[8255]')
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('Eng/MEvtManage/EngMEvtViewToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            //导入
            impt() {
                let item = {
                    //label: '物料主文件导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/45',
                    url: '/exp/45',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/45'});
                this.$store.commit('selectMenu', item);
            },
            // 保存
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = that.dataDetail.Head;
                console.log(that.dataDetail.Head);
                that.$http.urlpost('Eng/MEvtManage/SaveEngMEvtInfo', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = res.UniqueNum;
                        that.code = parm;
                        that.getDetail(parm);
                    }
                });
            },
            // 删除
            del(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            Code: that.code
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('Eng/MEvtManage/DeleteEngMEvtInfo', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 选择项目信息
            selectItem(){
                let that = this
                that.$refs.item.clearInput(true);
            },
            getItem(val){
                let that = this
                console.log(val)
                that.dataDetail.Head.item_code = val.item_code
                that.dataDetail.Head.item_name = val.item_name
                that.dataDetail.Head.item_status_name = val.item_status
                that.dataDetail.Head.itemid = val.exclusively_id
                that.dataDetail.Head.leadcadrename = val.item_duty_person
                that.dataDetail.Head.leadcadreinbox = val.email
            },
             // 选择工艺加工信息
             selectprocess(){
                let that = this
                that.$refs.process.clearInput(true);
            },
            getprocess(val){
                let that = this
                console.log(val)
                that.dataDetail.Head.machingprocess = val.craftname
                that.dataDetail.Head.process_unit_price = val.unit_price
            },
            selectPart(){
                let that = this
                that.$refs.part.clearInput(true);
            },
            getPart(val){
                let that = this
                console.log(val)
                that.dataDetail.Head.part_code = val.part_code
                that.dataDetail.Head.part_version = val.part_version
                that.dataDetail.Head.partid = val.exclusively_id
            },
            selectEmployee(){
                let that = this
                that.$refs.employee.clearInput(true);
            },
            getEmployee(val){
                let that = this
                console.log(val)
                that.dataDetail.Head.leadcadrecode = val.code
                that.dataDetail.Head.leadcadrename = val.name
                that.dataDetail.Head.leadcadreinbox = val.email
            },
            // 上传
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.file = file.raw
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(res.Msg);
                } else {
                    console.log('导入成功')
                }
                that.fileList=[];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            uploadFile(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file);
                formData.append('Code', that.dataDetail.Head.mevt_no)
                that.$http.urlpost('Eng/MEvtManage/MEvtUpLoadFile', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.authority();
                    }
                });
            },
            confirm(){
                let that = this
                that.$confirm('确认提交?', that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.dataDetail.Head.exclusively_id,
                            mevt_no: that.dataDetail.Head.mevt_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            status: that.dataDetail.Head.status,
                            iswork: that.dataDetail.Head.iswork,
                            LangType: that.$processdata.getLang()
                        }
                        that.$http.urlpost('Eng/MEvtManage/EngMEvtConfirm', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getDetail(that.code)
                                that.authority();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            //工程分析提交
            engineerconfirm(){
                let that = this
                that.$confirm(that.$t('getapi[8737]'), that.$t('getapi[194]'), {//'确认并发送相关邮件?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.dataDetail.Head.exclusively_id,
                            mevt_no: that.dataDetail.Head.mevt_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            status: that.dataDetail.Head.status,
                            pro_type: that.dataDetail.Head.pro_type,
                            iswork: that.dataDetail.Head.iswork,
                            // size: that.dataDetail.Head.size,
                            // otherreq: that.dataDetail.Head.otherreq,
                            machingprocess:that.dataDetail.Head.machingprocess,
                            machingremarks:that.dataDetail.Head.machingremarks,                            
                            psm_minute:that.dataDetail.Head.psm_minute, 
                            omm_minute:that.dataDetail.Head.omm_minute, 
                            gr_minute:that.dataDetail.Head.gr_minute, 
                            dril_minute:that.dataDetail.Head.dril_minute, 
                            tapping_minute:that.dataDetail.Head.tapping_minute, 
                            wedm_ms_minute:that.dataDetail.Head.wedm_ms_minute, 
                            wedm_hs_minute:that.dataDetail.Head.wedm_hs_minute, 
                            cnc_one_minute:that.dataDetail.Head.cnc_one_minute, 
                            cnc_two_minute:that.dataDetail.Head.cnc_two_minute, 
                            cnc_minute:that.dataDetail.Head.cnc_minute, 
                            gmc_minute:that.dataDetail.Head.gmc_minute, 
                            cnc_precision_minute:that.dataDetail.Head.cnc_precision_minute, 
                            cnc_gantry_minute:that.dataDetail.Head.cnc_gantry_minute, 
                            cnc_milling_minute:that.dataDetail.Head.cnc_milling_minute, 
                            process_unit_price:that.dataDetail.Head.process_unit_price, 
                            issendeail: 1,
                            LangType: that.$processdata.getLang(),
                        }
                        that.$http.urlpost('/Eng/MEvtManage/EngMEvtEngineAnalysis', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getDetail(that.code)
                                that.authority();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            //询价分析提交
            inquiryconfirm(){
                let that = this
                that.$confirm(that.$t('getapi[8737]'), that.$t('getapi[194]'), {//'确认并发送相关邮件?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.dataDetail.Head.exclusively_id,
                            mevt_no: that.dataDetail.Head.mevt_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            status: that.dataDetail.Head.status,
                            material: that.dataDetail.Head.material,
                            gross_weight: that.dataDetail.Head.gross_weight,
                            unit_price: that.dataDetail.Head.unit_price,
                            material_cost: that.dataDetail.Head.material_cost,
                            enquiryprice_tax: that.dataDetail.Head.enquiryprice_tax,
                            issendeail: 1,
                            LangType: that.$processdata.getLang()
                        }
                        that.$http.urlpost('Eng/MEvtManage/EngMEvtInquiry', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getDetail(that.code)
                                that.authority();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            // 生产评估并发送邮件
           proevaluationconfirm(){
                let that = this
                that.$confirm(that.$t('getapi[8737]'), that.$t('getapi[194]'), {//'确认并发送相关邮件?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.dataDetail.Head.exclusively_id,
                            mevt_no: that.dataDetail.Head.mevt_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            iswork: that.dataDetail.Head.iswork,
                            LangType: that.$processdata.getLang()
                        }
                        that.$http.urlpost('Eng/MEvtManage/UpdateEngMEvtInfoPro', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getDetail(that.code)
                                that.authority();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            // 机加工
            machiningconfirm(){
                let that = this
                that.$confirm(that.$t('getapi[8737]'), that.$t('getapi[194]'), {//'确认并发送相关邮件?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.dataDetail.Head.exclusively_id,
                            mevt_no: that.dataDetail.Head.mevt_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            iswork: that.dataDetail.Head.iswork,
                            status: that.dataDetail.Head.status,
                            pro_type: that.dataDetail.Head.pro_type,
                            size: that.dataDetail.Head.size,
                            otherreq: that.dataDetail.Head.otherreq,
                            issendeail:1,
                            LangType: that.$processdata.getLang()
                        }
                        that.$http.urlpost('Eng/MEvtManage/EngMEvtMachining', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getDetail(that.code)
                                that.authority();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            //生产提交
            proconfirm(){
                let that = this
                that.$confirm(that.$t('getapi[8737]'), that.$t('getapi[194]'), {//'确认并发送相关邮件?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.dataDetail.Head.exclusively_id,
                            mevt_no: that.dataDetail.Head.mevt_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            status: that.dataDetail.Head.status,
                            rawmaterial_code: that.dataDetail.Head.rawmaterial_code,
                            material_no: that.dataDetail.Head.material_no,
                            standardcosts: that.dataDetail.Head.standardcosts,
                            issendeail:1,
                            LangType: that.$processdata.getLang()
                        }
                        that.$http.urlpost('Eng/MEvtManage/EngMEvtPRO', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getDetail(that.code)
                                that.authority();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            // 强制关闭
            forceclose(){
                let that = this
                that.$confirm(that.$t('getapi[8725]'), that.$t('getapi[194]'), {//确认强制关闭？
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.dataDetail.Head.exclusively_id,
                            mevt_no: that.dataDetail.Head.mevt_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            status: that.dataDetail.Head.status,
                        }
                        that.$http.urlpost('/Eng/MEvtManage/EngMEvtClose', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getDetail(that.code)
                                that.authority();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            exp(val){
                // 0生成、1提交、2评估中、3 报价评估完成、4生产评估、5生产评估中、6完成、7关闭
                if(val == 0){
                    return this.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return this.$t('getapi[6468]')//'提交'
                } else if(val == 2){
                    return this.$t('getapi[8925]')//'评估中'
                } else if(val == 3){
                    return this.$t('getapi[13242]')//'报价评估完成'
                } else if(val == 4){
                    return this.$t('getapi[13239]')//'生产评估'
                } else if(val == 5){
                    return this.$t('getapi[13243]')//'生产评估中'
                } else if(val == 6){
                    return this.$t('getapi[8916]')//'完成'
                } else if(val == 7){
                    return this.$t('getapi[441]')//'关闭'
                } else {
                    return ''
                }
            },
            handleSelectionChangeAll({ records }){
                let that = this;
                that.selectData = [];
                that.selectData = records;
            },
            // 多选
            handleSelectionChange({checked, records }) {
                let that = this;
                that.selectData = [];
                that.selectData = records;
                console.log(that.selectData.length)
            },
            batchdel(){
                let that = this
                that.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确认删除?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = ''
                        let paths = ''
                        for(let i = 0;i<that.selectData.length;i++){
                            ids = ids + that.selectData[i].exclusively_id + ','
                            paths = paths + that.selectData[i].path + ','
                        }
                        ids = ids.substring(0,ids.length-1)
                        paths = paths.substring(0,paths.length-1)
                        let parm = {
                            "ids": ids,
                            "FilesSrc": paths
                        }
                        that.$http.urlpost('/Eng/MEvtManage/DelItemFileByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getDetail(that.code)
                                that.authority();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 556,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.List.length;i++){
                    delete datacopy.List[i]['_XID'];
                }
                let flag = that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }

    .quill-editor.myQuillEditor {
        height: 600px;
        overflow-y: auto;
    }
    /deep/.yellow{
        background: #EE7700;
    }
</style>
